import React, { useMemo } from 'react';

import { PathwaysStatRes } from '../types';

export const usePathwayStatAndProgressValue = (
  pathwaysStat: PathwaysStatRes | null | undefined,
) => {
  return useMemo(() => {
    if (pathwaysStat?.completed === undefined || !pathwaysStat?.total) return ['', null];

    return [
      () => (
        <>
          {pathwaysStat.completed || 0}
          <span>/{pathwaysStat?.total}</span>
        </>
      ),
      ((pathwaysStat?.completed || 0) / pathwaysStat.total) * 100,
    ];
  }, [pathwaysStat]);
};
